import Services from "./services/index.js";

export default [
    ...Services,
]
